/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bulb': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<defs/><path pid="0" id="bulb" class="cls-1" d="M1691.5 37.167h1.67V38h1.66v-.833h1.67V35.5h-5v1.667zm2.5-15a5.831 5.831 0 0 0-2.5 11.1v.568a.831.831 0 0 0 .83.833h3.34a.831.831 0 0 0 .83-.833v-.569a5.831 5.831 0 0 0-2.5-11.099zm1.39 9.757a.841.841 0 0 0-.56.785V33h-1.66v-.29a.841.841 0 0 0-.56-.785 4.17 4.17 0 1 1 2.78-.001zM1694.83 18h-1.66v3.333h1.66V18zM1684 28.833h3.33v-1.666H1684v1.667zm16.67-1.667v1.667h3.33v-1.666h-3.33zm1.42-6.078l-1.18-1.178-2.5 2.5 1.18 1.178zm-12.5 1.322l-2.5-2.5-1.18 1.178 2.5 2.5z" transform="translate(-1684 -18)"/>'
  }
})
